import { render, staticRenderFns } from "./OrmBatchStatistics.vue?vue&type=template&id=1fa60d45"
import script from "./OrmBatchStatistics.vue?vue&type=script&lang=js"
export * from "./OrmBatchStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fa60d45')) {
      api.createRecord('1fa60d45', component.options)
    } else {
      api.reload('1fa60d45', component.options)
    }
    module.hot.accept("./OrmBatchStatistics.vue?vue&type=template&id=1fa60d45", function () {
      api.rerender('1fa60d45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ormbatching/components/OrmBatchStatistics.vue"
export default component.exports